import GenericDeleteContainer from "components/GenericDelete/GenericDeleteContainer";
import ToastContainer from "components/Toast/ToastContainer";

const AppContainers = () => (
  <>
    <ToastContainer />
    <GenericDeleteContainer />
  </>
);

export default AppContainers;
